import React, { Component } from 'react'

class GooglePay extends Component {
    componentDidMount = () => {
        window.gapi.savetoandroidpay.render("dom-container", {
            "jwt": this.props.jwt,
            "onsuccess": this.successHandler,
            "onfailure": this.failureHandler,
        })
    }
    saveToPay = () => {
        window.gapi.savetoandroidpay.render("dom-container", {
            "jwt": this.props.jwt,
            "onsuccess": (data) => this.successHandler(data),
            "onfailure": (err) => this.failureHandler(err)
        })
    }
    failureHandler = (err) => {
        console.log('failure', err)
    }
    successHandler = (data) => {
        console.log('success', data);
        this.props.onSaveToWallet();
    }
    render() {
        return (
                <div id="dom-container"></div>
        )
    }
}

export default GooglePay;